import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Edit } from 'lucide-react';

interface DebtorLocationTabProps {
  debtor: any;
  debtorId: string;
}

export default function DebtorLocationTab({ debtor, debtorId }: DebtorLocationTabProps) {
  const navigate = useNavigate();
  const hasLocation = debtor.latitude && debtor.longitude;

  return (
    <div className="bg-white border rounded-lg">
      <div className="p-4 border-b">
        <h3 className="text-lg font-semibold">Lokasi Alamat</h3>
        <p className="text-sm text-gray-500">
          {hasLocation
            ? `Koordinat: ${debtor.latitude.toFixed(6)}, ${debtor.longitude.toFixed(6)}`
            : 'Lokasi belum ditandai pada peta'}
        </p>
      </div>
      <div className="p-4">
        {hasLocation ? (
          <div className="h-[400px] rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
            {/* Map placeholder - bisa diganti dengan Leaflet atau OpenStreetMap */}
            <div className="text-center">
              <MapPin className="w-12 h-12 mx-auto mb-3 text-amber-500" />
              <p className="text-gray-600 font-medium">Lokasi Tersedia</p>
              <p className="text-sm text-gray-500 mt-1">
                Lat: {debtor.latitude}, Lng: {debtor.longitude}
              </p>
              <a
                href={`https://www.google.com/maps?q=${debtor.latitude},${debtor.longitude}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-3 px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors"
              >
                Buka di Google Maps
              </a>
            </div>
          </div>
        ) : (
          <div className="h-[400px] bg-gray-100 rounded-lg flex items-center justify-center">
            <div className="text-center">
              <MapPin className="w-12 h-12 mx-auto mb-3 text-gray-300" />
              <p className="text-gray-500">Lokasi belum ditandai</p>
              <button
                onClick={() => navigate(`/debtorform?id=${debtorId}`)}
                className="inline-flex items-center gap-2 mt-3 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <Edit className="w-4 h-4" /> Tandai Lokasi
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
